'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _components = require('components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LibraryHeader = function (_React$Component) {
  (0, _inherits3.default)(LibraryHeader, _React$Component);

  function LibraryHeader() {
    (0, _classCallCheck3.default)(this, LibraryHeader);
    return (0, _possibleConstructorReturn3.default)(this, (LibraryHeader.__proto__ || (0, _getPrototypeOf2.default)(LibraryHeader)).apply(this, arguments));
  }

  (0, _createClass3.default)(LibraryHeader, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          screen = _props.screen,
          loggedIn = _props.loggedIn,
          currentType = _props.currentType,
          currentPackId = _props.currentPack,
          searchState = _props.searchState,
          packs = _props.packs;

      var currentPack = packs && packs.find(function (p) {
        return p.id == currentPackId;
      });

      var styles = require('./LibraryHeader.scss');

      return _react2.default.createElement(
        'div',
        { className: styles.LibraryHeader },
        currentPack && !currentPack.isIncomplete && _react2.default.createElement(_components.PackHeader, { pack: currentPack }),
        _react2.default.createElement(
          'div',
          { className: styles.LibraryHeader__fatSection },
          !currentPack ? _react2.default.createElement(
            'div',
            { className: styles.LibraryHeader__adsSlider },
            _react2.default.createElement(_components.AdsSlider, { disabled: screen != 'slider' })
          ) : _react2.default.createElement(_components.LibraryPackHeader, { pack: currentPack })
        ),
        !currentPack && _react2.default.createElement(_components.LibraryNavBar, {
          loggedIn: loggedIn,
          searchFocused: searchState.focused,
          packs: packs,
          currentType: currentType })
      );
    }
  }]);
  return LibraryHeader;
}(_react2.default.Component);

exports.default = LibraryHeader;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/LibraryHeader/LibraryHeader.jsx
// module id = 2618
// module chunks = 0